import * as B from '@blueprintjs/core';
import {DataSnapshot, off as dbRefOff, ref as getDatabaseRef, onValue} from 'firebase/database';
import React from 'react';

import {usePushNotification} from 'app/components/Notification';
import {useFirebaseDatabase} from 'app/tools/Firebase';

/**
 * Needs to be rendered underneath AuthProvider so that the firebase app is set
 * up.
 */
const VersionUpdateMonitor: React.FunctionComponent<React.PropsWithChildren<{}>> = () => {
  const database = useFirebaseDatabase();
  const versionRef = React.useRef<number | undefined>(undefined);
  const pushNotification = usePushNotification();

  const pushNotificationRef = React.useRef(pushNotification);

  React.useEffect(() => {
    pushNotificationRef.current = pushNotification;
  }, [pushNotification]);

  React.useEffect(() => {
    const realtimeVersionRef = getDatabaseRef(database, 'realtime/versions/lens');

    // TODO(fiona): The old code had this debounced by 3000ms. Is that still
    // important?
    const handleVersionValue = (snapshot: DataSnapshot) => {
      const version: number = snapshot.val();
      if (versionRef.current === undefined) {
        versionRef.current = version;
      } else if (version > versionRef.current) {
        console.info(
          `New version is available. Previous version ${versionRef.current}. New version ${version}.`
        );

        pushNotificationRef.current({
          message:
            'A new version of the application is now available! Please refresh to get the latest version.',
          autoHideDuration: 0,
          options: {intent: B.Intent.WARNING, icon: 'automatic-updates'},
        });
      }
    };

    onValue(realtimeVersionRef, handleVersionValue);

    return () => {
      dbRefOff(realtimeVersionRef, 'value', handleVersionValue);
    };
  }, [database]);

  return null;
};

export default VersionUpdateMonitor;
